import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { PLATFORM, TOP_UP_URL, CREDITS_EVENT } from "@/lib/platform";

// The platform refused an AI call (out of credits, monthly limit, not in
// plan): its message, and on the platform a link to top up. Only ever shown
// in platform mode; standalone the API never sends the signal.
export default function CreditsNotice() {
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const on = (e) => setMsg(e.detail || "");
    window.addEventListener(CREDITS_EVENT, on);
    return () => window.removeEventListener(CREDITS_EVENT, on);
  }, []);

  if (!msg) return null;
  return (
    <div
      role="alert"
      data-testid="credits-notice"
      className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-3 border-b border-red-200 bg-red-50 px-4 py-2.5 text-sm text-red-700"
    >
      <span>{msg}</span>
      {PLATFORM && (
        <a href={TOP_UP_URL} className="font-semibold underline underline-offset-2" data-testid="credits-top-up-link">
          Top up
        </a>
      )}
      <button onClick={() => setMsg("")} aria-label="Close" className="rounded-full p-1.5 text-red-700/70 hover:bg-white hover:text-red-700">
        <X size={14} />
      </button>
    </div>
  );
}

// For an AI job that failed in the background (extraction): a top-up link
// when its stored error is the platform's out-of-credits message.
export function TopUpLink({ text }) {
  if (!PLATFORM || !/credit/i.test(text || "")) return null;
  return (
    <a href={TOP_UP_URL} className="font-semibold underline underline-offset-2 ml-1" data-testid="extraction-top-up-link">
      Top up
    </a>
  );
}
